
import React from "react";

const images = [
  "/Wedding.png",
  "/Taj.png",
  "/Badminton.png",
  "/Kaffee.png",
  "/Yoga.png",
  "/Laser.png"
];

const positiveWords = [
  "அன்பு", "நம்பிக்கை", "இணக்கம்", "மகிழ்ச்சி", "வாழ்க்கை", "பாசம்",
  "நகைச்சுவை", "உண்மை", "புரிதல்", "தன்னம்பிக்கை", "பண்பு", "சிறப்பு",
  "நேர்மை", "புதிய ஆற்றல்", "இனிமை", "நட்பு", "பகிர்வு", "அறிவு"
];

const AboutUs = () => {
  return (
    <div className="p-4 sm:p-6 md:p-8 max-w-5xl mx-auto text-gray-800" style={{ color: '#1f2937' }}>
      <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-6">எங்களைப் பற்றி – தாபோ & துச்சி</h1>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-8">
        {images.map((src, index) => (
          <img
            key={index}
            src={src}
            alt={`Couple ${index + 1}`}
            className="w-full h-88 sm:h-80 md:h-80 object-cover rounded-xl shadow-md"
          />
        ))}
      </div>

      <div className="bg-white shadow-md rounded-lg p-4 sm:p-6 text-sm sm:text-base md:text-lg leading-relaxed mb-6" style={{ color: '#1f2937' }}>
        <p>
          எங்க இருந்து ஆரம்பிக்கலாம்? ஒரே காரணம் – தாபோ தவறுதலாக துச்சியின் ஸ்டார்பக் காபியை எடுத்ததும், அத்துடன் அவளுடைய இதயத்தையும் கைப்பற்றியது. அதன் பின் நாங்கள், காதலால், சிரிப்பால், மற்றும் எந்த பீசாவில் அனனாஸ் சேர்க்கலாமா இல்லையா என்ற விவாதத்தால் இணைந்த நாயக தம்பதிகள்.
        </p>
        <p className="mt-4">
          தாபோ ஒரு டெக் மேஜீஷியன், மீம்ஸைப் பார்ப்பதில் மோகம். துச்சி – படைப்பாற்றலின் ராஜ்ஜியம், Pinterest குயின், மற்றும் இழந்த சாவிகளை கண்டுபிடிக்க கூல் ரடார் உள்ளது. நாங்கள் ஒரு Netflix ட்ரீம்-டீம் – சில நேரங்களில் டிராமா, பெரும்பாலும் காமெடி!
        </p>
        <p className="mt-4">
          இந்த பக்கம்? எங்களது காதல் நாட்குறிப்பு. இந்த சிறப்பான கட்டத்தை உங்களுடன் பகிர்வதில் மகிழ்ச்சி. பாருங்க, சிரி, சில சமயம் உருகுங்க – ஆனா ரொம்பயும் உருகாதீங்க.
        </p>
      </div>

      <div className="text-center text-xs sm:text-sm text-gray-500 px-2 mb-8">
        பி.எஸ்: எங்களை நேரில் காண வேண்டுமா? கல்யாணத்தில் வாருங்கள். ஸ்பொயிலர் அலர்ட்: டான்ஸ் இருக்கு, கேக் இருக்கு, மற்றும் தாபோவின் சூப்பர் மூன்வாக் இருக்கு!
      </div>

      <div className="bg-pink-50 rounded-2xl p-4 sm:p-6 shadow-inner">
        <h2 className="text-xl sm:text-2xl font-semibold text-center mb-4 text-gray-800">எங்கள் தன்மைகள் ❤️</h2>
        <div className="flex flex-wrap justify-center gap-3 sm:gap-4">
          {positiveWords.map((word, index) => (
            <span
              key={index}
              className="text-pink-700 text-base sm:text-lg md:text-xl font-bold animate-pulse"
              style={{
                transform: `rotate(${(index % 5) * 10 - 20}deg)`,
                display: 'inline-block'
              }}
            >
              {word}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
